export function shortestCircularDelta(fromAngle, toAngle) {
    const delta = Math.atan2(Math.sin(toAngle - fromAngle), Math.cos(toAngle - fromAngle));
    return Math.abs(Math.abs(delta) - Math.PI) < 1e-10 ? Math.PI : delta;
}
